// home container forms the frame for the auth screens
export default function HomeContainer({ children }) {
  return <div className="HomeContainer">{children}</div>;
}
